import {
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import EmptyData from "../../../Global/EmptyData";
import SubscriptionDetails from "../../CustomerSubscriptions/SubscriptionDetails";
import CancelSubscription from "../../CustomerSubscriptions/CancelSubscription";
import CreditBalance from "../../CustomerSubscriptions/CreditBalance";
import useSubscriptions from "./useSubscriptions";

const Subscriptions = () => {
  const {
    isLoading,
    isFetching,
    isForbidden,
    hasError,
    fields,
    subscriptionList,
    subscriptionState,
    paginationOptions,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    closeAction,
    handleSort,
    refetch,
    getRow,
  } = useSubscriptions();

  /*
    A refusal is reported as one. The empty state would read as "this customer has never
    bought a plan", which is a different claim and not one this response supports.
  */
  if (hasError) {
    return (
      <div className="col-auto pro-pt-3 pro-pb-6">
        <p className="pro-mb-0">
          {isForbidden
            ? "You do not have permission to view customer subscriptions."
            : "Could not load this customer's subscriptions. Please try again."}
        </p>
      </div>
    );
  }

  return (
    <div className="col-auto pro-pt-3 pro-pb-6">
      <SearchFilters
        onSearchInput={handleSearch}
        loading={isLoading}
        SearchIcon={<span className="material-symbols-outlined"> search </span>}
        showClearFilters={subscriptionState?.search === "" ? false : true}
        handleClear={handleClearClick}
        searchInputProps={{ value: subscriptionState?.search }}
      />

      {subscriptionList?.result?.length === 0 ? (
        <EmptyData />
      ) : (
        <Table
          multiSelect={false}
          data={subscriptionList?.result || []}
          uniqueID={"subscription_id"}
          fields={fields}
          SortIcon={<FaSort />}
          handleSort={handleSort}
          getRow={getRow}
          loading={isFetching}
          perpage={subscriptionState?.currentPageSize}
          assignable={false}
          editable={false}
          deletable={false}
          showCheckBox={false}
        />
      )}

      {subscriptionList?.result?.length > 0 && (
        <Pagination
          currentPage={subscriptionState?.currentPage}
          totalPageCount={Math.ceil(
            subscriptionList?.total_count / subscriptionState?.currentPageSize
          )}
          defaultValue={paginationOptions?.filter(
            (item) => item?.value === subscriptionState?.currentPageSize
          )}
          onPageChange={handlePagination}
          options={paginationOptions}
          onActionChange={handlePageSize}
          center
        />
      )}

      {/* lg: the ledger table needs more than the default dialog width. */}
      <ModalLayout
        show={subscriptionState?.showDetailsModal}
        handleClose={() => closeAction("showDetailsModal")}
        backdrop="static"
        size="lg"
      >
        <div className="pro-m-5">
          <SubscriptionDetails
            subscriptionId={subscriptionState?.selectedId}
            handleClose={() => closeAction("showDetailsModal")}
          />
        </div>
      </ModalLayout>

      {/*
        The same dialogs the Customer Subscriptions screen opens, given the same row and the
        same refetch - so a credit or a cancellation lands on this tab's own listing rather
        than leaving it showing the balance it had a moment ago.
      */}
      <ModalLayout
        show={subscriptionState?.showCancelModal}
        handleClose={() => closeAction("showCancelModal")}
        backdrop="static"
      >
        <div className="pro-m-5">
          <CancelSubscription
            subscription={subscriptionState?.selectedSubscription}
            handleClose={() => closeAction("showCancelModal")}
            refetch={refetch}
          />
        </div>
      </ModalLayout>

      <ModalLayout
        show={subscriptionState?.showCreditModal}
        handleClose={() => closeAction("showCreditModal")}
        backdrop="static"
      >
        <div className="pro-m-5">
          <CreditBalance
            subscription={subscriptionState?.selectedSubscription}
            handleClose={() => closeAction("showCreditModal")}
            refetch={refetch}
          />
        </div>
      </ModalLayout>
    </div>
  );
};

export default Subscriptions;
